import React from "react";
import { useParams } from 'react-router-dom';
import { getMasterDataSiteInfo, getAllDropdowns, moveSiteDraft, updateSiteDraft, getSiteDraftById, getAllSiteType, getAllDepotList, getSiteAccessBaseData, getAllDistrict, getAllEnergyCategory, getAllSiteCategory, getAllSiteOwner, getAllEntity, getAllTowerCategory, getAllTowerType, getAllCoolingMethods, getAllShelterType, getAllGenHutType } from "../../api/index";
import { Form, Input, Button, Row, Col, Select, message, DatePicker } from "antd";
import { useHistory } from 'react-router-dom';
import { all } from "redux-saga/effects";
import site from "../site";
import moment from "moment";

const DraftEditor = () => {
    const { id } = useParams();
    const [draft, setDraft] = React.useState(null);
    const history = useHistory();
    const [allSiteTypes, setAllSiteTypes] = React.useState([]);
    const [allDistricts, setAllDistricts] = React.useState([]);
    const [allEnergyCategories, setAllEnergyCategories] = React.useState([]);
    const [allSiteCategories, setAllSiteCategories] = React.useState([]);
    const [allSiteOwners, setAllSiteOwners] = React.useState([]);
    const [allEntities, setAllEntities] = React.useState([]);
    const [allTowerCategories, setAllTowerCategories] = React.useState([]);
    const [allTowerTypes, setAllTowerTypes] = React.useState([]);
    const [allCoolingMethods, setAllCoolingMethods] = React.useState([]);
    const [allShelterTypes, setAllShelterTypes] = React.useState([]);
    const [allGenHutTypes, setAllGenHutTypes] = React.useState([]);
    const [accessPermitionGroupType, setAccessPermitionGroupType] = React.useState([]);
    const [allDepotList, setAllDepotList] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [transformedDraft, setTransformedDraft] = React.useState(null);

    const [allDropDowns, setAllDropDowns] = React.useState([]);
    const [allPowerDetails, setAllPowerDetails] = React.useState([]);

    React.useEffect(() => {
        const fetchDraft = async () => {
            const response = await getSiteDraftById(id);
            if (response && response.success) {
                setDraft(response.data);
                setTransformedDraft(transformApiResponse(response.data));
            }
        };
        fetchDraft();
        getDataAllSiteType();
        getDataAllDistrict();
        getDataAllEnergyCategory();
        getDataAllSiteCategory();
        getDataAllSiteOwner();
        getDataAllEntity();
        getDataAllTowerCategory();
        getDataAllTowerType();
        getDataAllCoolingMethods();
        getDataAllShelterType();
        getDataAllGenHutType();
        getDataSiteAccessBaseData();
        getAllDepotData();
        fetchAllDropdowns();
        getDataAllPowerDetails();
    }, [id]);

    const fetchAllDropdowns = async () => {
        try {
            const response = await getAllDropdowns();
            if (response && response.success) {
                setAllDropDowns(response.data || []);
            }
        } catch (error) {
            console.error("Error fetching all dropdowns:", error);
        }
    };

    const updateDraft = async (values) => {
        setLoading(true);
        try {
            console.log('updateDraft values', values);
            let response = await updateSiteDraft(values);
            if (response && response.success) {
                message.success(<span className="textStyles-small">Draft updated successfully</span>);
                const response = await getSiteDraftById(id);
                if (response && response.success) {
                    setDraft(response.data);
                    setTransformedDraft(transformApiResponse(response.data));
                }
            } else {
                message.error("Failed to update draft");
            }
        } catch (error) {
            console.error("Error updating draft:", error);
        }
        setLoading(false);
    }

    const moveDraft = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('draftId', String(draft.id));
            let response = await moveSiteDraft(formData);
            if (response && response.success) {
                message.success(<span className="textStyles-small">Draft moved to site successfully</span>);
                history.push('/data-collection/all-drafts');
            } else {
                message.error(<span className="textStyles-small">Failed to move draft to site</span>);;
            }
        } catch (error) {
            console.error("Error moving draft:", error);
        }
        setLoading(false);
    }

    const transformApiResponse = (data) => {
        const topKeys = ["id", "siteN360Id", "siteName", "updatedOn", "createdOn", "moveSite", "missingFields"];
        const transformed = {
            id: data.id,
            siteN360Id: data.siteN360Id,
            siteName: data.siteName,
            updatedOn: data.updatedOn,
            createdOn: data.createdOn,
            moveSite: data.moveSite,
            missingFields: data.missingFields,
            fieldList: []
        };
        for (const key in data) {
            if (!topKeys?.includes(key)) {
                transformed?.fieldList.push({
                    key,
                    value: data[key]
                });
            }
        }
        return transformed;
    };

    const getAllDepotData = async () => {
        try {
            const res = await getAllDepotList();
            if (res && res.success) {
                setAllDepotList(res.data || []);
            }
        } catch (err) {
            console.error('getAllDepotList error', err);
        }
    }

    const getDataSiteAccessBaseData = async () => {
        try {
            const res = await getSiteAccessBaseData();
            if (res && res.success) {
                setAccessPermitionGroupType(res.data?.accessPermitionGroups || []);
            }
        } catch (err) {
            console.error('getSiteAccessBaseData error', err);
        }
    };

    const getDataAllShelterType = async () => {
        try {
            const res = await getAllShelterType();
            if (res && res.success) {
                setAllShelterTypes(res.data || []);
            }
        } catch (err) {
            console.error('getAllShelterType error', err);
        }
    };

    const getDataAllGenHutType = async () => {
        try {
            const res = await getAllGenHutType();
            if (res && res.success) {
                setAllGenHutTypes(res.data || []);
            }
        } catch (err) {
            console.error('getAllGenHutType error', err);
        }
    };

    const getDataAllTowerType = async () => {
        try {
            const res = await getAllTowerType();
            if (res && res.success) {
                setAllTowerTypes(res.data || []);
            }
        } catch (err) {
            console.error('getAllTowerType error', err);
        }
    };

    const getDataAllCoolingMethods = async () => {
        try {
            const res = await getAllCoolingMethods();
            if (res && res.success) {
                setAllCoolingMethods(res.data || []);
            }
        } catch (err) {
            console.error('getAllCoolingMethods error', err);
        }
    };

    const getDataAllTowerCategory = async () => {
        try {
            const res = await getAllTowerCategory();
            if (res && res.success) {
                setAllTowerCategories(res.data || []);
            }
        } catch (err) {
            console.error('getAllTowerCategory error', err);
        }
    };

    const getDataAllEntity = async () => {
        try {
            const res = await getAllEntity();
            if (res && res.success) {
                setAllEntities(res.data || []);
            }
        } catch (err) {
            console.error('getAllEntity error', err);
        }
    };

    const getDataAllSiteOwner = async () => {
        try {
            const res = await getAllSiteOwner();
            if (res && res.success) {
                setAllSiteOwners(res.data || []);
            }
        } catch (err) {
            console.error('getAllSiteOwner error', err);
        }
    };

    const getDataAllSiteCategory = async () => {
        try {
            const res = await getAllSiteCategory();
            if (res && res.success) {
                setAllSiteCategories(res.data || []);
            }
        } catch (err) {
            console.error('getAllSiteCategory error', err);
        }
    };

    const getDataAllEnergyCategory = async () => {
        try {
            const res = await getAllEnergyCategory();
            if (res && res.success) {
                setAllEnergyCategories(res.data || []);
            }
        } catch (err) {
            console.error('getAllEnergyCategory error', err);
        }
    };

    const getDataAllDistrict = async () => {
        try {
            const res = await getAllDistrict();
            if (res && res.success) {
                setAllDistricts(res.data || []);
            }
        } catch (err) {
            console.error('getAllDistrict error', err);
        }
    };

    const getDataAllSiteType = async () => {
        try {
            const res = await getAllSiteType();
            if (res && res.success) {
                setAllSiteTypes(res.data || []);
            }
        } catch (err) {
            console.error('getAllSiteType error', err);
        }
    };

    const getDataAllPowerDetails = async () => {
        try {
            const res = await getMasterDataSiteInfo();
            if (res && res.success) {
                setAllPowerDetails(res?.data?.powerConnectionType || []);
            }
        } catch (err) {
            console.error('getPowerDetailsBySite error', err);
        }
    };

    const dataMapping = [
        { labelName: 'Depot', fieldName: 'depot', dataType: 'DROPDOWN', options: allDepotList, isRequired: true },
        { labelName: 'District', fieldName: 'district', dataType: 'DROPDOWN', options: allDistricts, isRequired: true },
        { labelName: 'Energy Category', fieldName: 'energyCategory', dataType: 'DROPDOWN', options: allEnergyCategories, isRequired: true },
        { labelName: 'Site Type', fieldName: 'siteType', dataType: 'DROPDOWN', options: allSiteTypes, isRequired: true },
        { labelName: 'Site Category', fieldName: 'siteCategory', dataType: 'DROPDOWN', options: allSiteCategories, isRequired: true },
        { labelName: 'No Of Phases', fieldName: 'noOfPhases', dataType: 'INT', options: null, isRequired: true },
        { labelName: 'Shelter Type', fieldName: 'shelterType', dataType: 'DROPDOWN', options: allShelterTypes, isRequired: true },
        { labelName: 'Access Permission Group', fieldName: 'accessPermitionGroup', dataType: 'DROPDOWN', options: accessPermitionGroupType, isRequired: true },
        { labelName: 'Site Owner', fieldName: 'siteOwner', dataType: 'DROPDOWN', options: allSiteOwners, isRequired: true },
        { labelName: 'Site Entity', fieldName: 'entity', dataType: 'DROPDOWN', options: allEntities, isRequired: true },
        { labelName: 'Site Status', fieldName: 'siteStatus', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Site On Air Date', fieldName: 'siteOnAirDate', dataType: 'DATE', options: null, isRequired: false },
        { labelName: 'Site Elevation', fieldName: 'siteElevation', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Tower Category', fieldName: 'towerCategory', dataType: 'DROPDOWN', options: allTowerCategories, isRequired: true },
        { labelName: 'Tower Type', fieldName: 'towerType', dataType: 'DROPDOWN', options: allTowerTypes, isRequired: true },
        { labelName: 'Tower Owner Category', fieldName: 'towerOwnerCategory', dataType: 'TEXT', options: null, isRequired: true },

        { labelName: 'Tower Height', fieldName: 'towerHeight', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Tower Legs Count', fieldName: 'towerLegsCount', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'PG Manual Distance', fieldName: 'pgMannualDistance', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Refuel Manual Distance', fieldName: 'refuelManualDistance', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Distance from Regional Office', fieldName: 'regionToSiteDistance', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Longitude', fieldName: 'longitude', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Latitude', fieldName: 'latitude', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Address', fieldName: 'address', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Available Generator Hut 1 Type', fieldName: 'availableGeneratorHut1Type', dataType: 'DROPDOWN', options: allGenHutTypes, isRequired: true },
        { labelName: 'Available Generator Hut 2 Type', fieldName: 'availableGeneratorHut2Type', dataType: 'DROPDOWN', options: allGenHutTypes, isRequired: true },
        { labelName: 'No. of tenants', fieldName: 'tenants', dataType: 'INT', options: null, isRequired: false },

        { labelName: 'Power Shared Tenants', fieldName: 'powerSharedTenants', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Indoor Outdoor', fieldName: 'indoorOutdoorType', dataType: 'DROPDOWN', options: null, isRequired: false },
        { labelName: 'Ambient Temperature', fieldName: 'ambientTemperature', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Dimension', fieldName: 'dimension', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Dependent CellCount', fieldName: 'dependentCellCount', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Travel Time From Depot', fieldName: 'travelTimeFromDepot', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Working Days Accessible Hours', fieldName: 'workingDaysAccessibleHours', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Weekends Or Holidays Accessible Hours', fieldName: 'weekendsOrHolidaysAccessibleHours', dataType: 'TEXT', options: null, isRequired: false },

        { labelName: 'Year of the JFS', fieldName: 'yearoftheJFS', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Access Permission Providing Party', fieldName: 'accessPermissionProvidingParty', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Active Passive', fieldName: 'activePassive', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Site Topology Terrain Mapping', fieldName: 'siteTopologyTerrainMapping', dataType: 'DROPDOWN', options: null, isRequired: false },
        { labelName: 'Vehicle Type', fieldName: 'vehicleType', dataType: 'DROPDOWN', options: null, isRequired: false },
        { labelName: 'Time Restricted Reason', fieldName: 'timeRestrictedReason', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'PIS vendor', fieldName: 'pisVendor', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Land Areain Perch', fieldName: 'landAreainPerch', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Key Location', fieldName: 'keyLocation', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Site Owner Name', fieldName: 'sOwnerName', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Site Owner Address', fieldName: 'sOwnerAddress', dataType: 'TEXT', options: null, isRequired: false },
        { labelName: 'Cooling Methods', fieldName: 'coolingMethods', dataType: 'DROPDOWN', options: allCoolingMethods, isRequired: true },
        { labelName: 'Site Rank', fieldName: 'siteRank', dataType: 'INT', options: null, isRequired: false },
        { labelName: 'Status', fieldName: 'status', dataType: 'TEXT', options: null, isRequired: false },

        { labelName: 'Standby Generator Availability', fieldName: 'isStandbyGeneratorAvailable', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: true },
        { labelName: 'PG Possibility', fieldName: 'pgPossibility', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: true },
        { labelName: 'Access Permission Required', fieldName: 'isAccessPermissionRequired', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Site Key Required', fieldName: 'isSiteKeyRequired', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Portable Gen Connecting Setup Availability', fieldName: 'portablegenConnectingSetupAvailability', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Idle Generator Hut Avaialability', fieldName: 'isIdleGeneratorHutAvaialable', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Space Available New Gen', fieldName: 'isSpaceAvailableNewGen', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'FreeLand Available', fieldName: 'freeLandAvailable', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Non Shading Space Availability Onshelter', fieldName: 'nonShadingSpaceAvailabilityOnshelter', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Non Shading Space Availability Ground', fieldName: 'nonShadingSpaceAvailabilityGround', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false },
        { labelName: 'Manual Transport', fieldName: 'manualTransport', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: true },

        { labelName: 'Tower Legs', fieldName: 'towerLegs', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Rectification Rank', fieldName: 'rectificationRank', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Generator Running Hours Last Month', fieldName: 'genRunningHoursLastMonth', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Generator Last Filling Quantity', fieldName: 'genLastFillingQty', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Rectifiers Count', fieldName: 'rectifiresCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Solar Generation Last Month', fieldName: 'solarGenerationLastMonth', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Land Area', fieldName: 'landArea', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Horizontal Distance', fieldName: 'horizontalDistance', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Vertical Distance', fieldName: 'verticalDistance', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Boat Distance', fieldName: 'boatDistance', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Travel Time', fieldName: 'travelTime', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Number of Indoor Cabins', fieldName: 'noOfIndoorCabins', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Total Capacity', fieldName: 'totalCap', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Remaining Capacity', fieldName: 'remainingCap', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'DC Load', fieldName: 'dcLoad', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Peak DC Load', fieldName: 'peakDcLoad', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Cabinet Count', fieldName: 'cabinetCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Cabinets with Equipment', fieldName: 'cabinetsWithEquipment', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'DCDU Count', fieldName: 'dcduCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Generator Hut Count', fieldName: 'genHutCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'ATS Count', fieldName: 'atsCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Air Conditioner Count', fieldName: 'airConditionerCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'FCB Count', fieldName: 'fcbCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'SPD Count', fieldName: 'spdCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Generator Count', fieldName: 'genCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Battery Bank Count', fieldName: 'batteryBankCount', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Total Battery Capacity', fieldName: 'totalBatteryCap', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Battery Designed Backup Time', fieldName: 'batteryDesignedBackUpTime', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Battery Allocated Backup Time', fieldName: 'batteryAllocatedBackUpTime', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Battery Actual Backup Time', fieldName: 'batteryActualBackUpTime', dataType: 'INT', options: [], isRequired: false  },
        { labelName: 'Battery Rack Count', fieldName: 'batteryRackCount', dataType: 'INT', options: [], isRequired: false  },

        { labelName: 'Grid Power Type', fieldName: 'gridPowerType', dataType: 'DROPDOWN', options: allPowerDetails, isRequired: false  },
        { labelName: 'Indoor Cabin Type', fieldName: 'indoorCabinType', dataType: 'DROPDOWN', options: allDropDowns?.["General Details"]?.["Indoor Cabin Type"] ?? [].map(option => ({ label: option.name, value: option.id })), isRequired: false  },
        { labelName: 'Generator Hut 1 Type', fieldName: 'genHut1Type', dataType: 'DROPDOWN', options: allGenHutTypes, isRequired: true  },
        { labelName: 'Generator Hut 2 Type', fieldName: 'genHut2Type', dataType: 'DROPDOWN', options: allGenHutTypes, isRequired: true  },
        { labelName: 'Space for New Generator', fieldName: 'spaceForNewGen', dataType: 'DROPDOWN', options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }], isRequired: false  },
        { labelName: 'AC Cooling Method', fieldName: 'acCoolingMethod', dataType: 'DROPDOWN', options: allDropDowns?.["General Details"]?.["Cooling Method"] ?? [].map(option => ({ label: option.name, value: option.id })), isRequired: false  },

        { labelName: 'Electricity Account Number', fieldName: 'electricityAccountNumber', dataType: 'TEXT', options: [], isRequired: false  },
        { labelName: 'Latest CEA Report Submission', fieldName: 'latestCeaReportSubmission', dataType: 'DATE', options: [], isRequired: false  },
        { labelName: 'TRCSL Report Submission', fieldName: 'trcslReportSubmission', dataType: 'DATE', options: [], isRequired: false  }
    ];

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">
                                    <span className="textStyles-small" style={{ fontSize: 16 }}>{draft?.siteName?.replace(/_/g, ' ')} Draft</span>
                                </h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Draft Editor</span>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>{draft?.siteName?.replace(/_/g, ' ')} Draft</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: 15 }}>
                <div style={{ padding: '20px 20px 20px 20px' }}>
                    {draft && (
                        <Form
                            layout="vertical"
                            onFinish={(values) => {
                                let keys = Object.keys(values);
                                let json = {};
                                keys.forEach(key => {
                                    const mapping = dataMapping.find(m =>
                                        m.fieldName.toLowerCase() === key.toLowerCase() ||
                                        m.fieldName.replace(/_/g, '').toLowerCase() === key.replace(/_/g, '').toLowerCase()
                                    );
                                    const dataType = mapping?.dataType || (typeof values[key] === 'number' ? 'INT' : 'TEXT');

                                    if (dataType === 'DROPDOWN' &&
                                        !['indoorCabinType', 'spaceForNewGen', 'acCoolingMethod', 'isStandbyGeneratorAvailable', 'pgPossibility', 'isAccessPermissionRequired', 'isSiteKeyRequired', 'portablegenConnectingSetupAvailability', 'isIdleGeneratorHutAvaialable', 'isSpaceAvailableNewGen', 'freeLandAvailable', 'nonShadingSpaceAvailabilityOnshelter', 'nonShadingSpaceAvailabilityGround', 'manualTransport'].includes(key)) {
                                        const option = mapping?.options?.find(opt =>
                                            (opt.value !== undefined && opt.value === values[key]) ||
                                            (opt.id !== undefined && opt.id === values[key])
                                        );
                                        json[key] = option ? option : values[key];
                                    } else if (dataType === 'INT') {
                                        json[key] = Number(values[key]);
                                    } else {
                                        json[key] = values[key];
                                    }
                                });
                                Object.assign(json, {
                                    id: draft?.id,
                                    siteN360Id: draft?.siteN360Id,
                                    siteName: draft?.siteName,
                                    updatedOn: draft?.updatedOn,
                                    createdOn: draft?.createdOn,
                                    moveSite: draft?.moveSite,
                                });
                                updateDraft(json);
                            }}
                        >
                            <Row>
                                {
                                    transformApiResponse(draft)?.fieldList?.filter(f => {
                                        const missing = draft?.missingFields ? draft.missingFields.split(',').map(x => x.trim().toLowerCase()) : [];
                                        console.log('checking field', f.key, 'missingFields', missing);
                                        return !missing.includes(!f.key.toLowerCase());
                                    })
                                        .map((fieldObj, index) => {
                                            console.log('processing fieldObj', fieldObj);
                                            const key = fieldObj.key;
                                            const mapping = dataMapping.find(m =>
                                                m.fieldName.toLowerCase() === key.toLowerCase() ||
                                                m.fieldName.replace(/_/g, '').toLowerCase() === key.replace(/_/g, '').toLowerCase()
                                            );
                                            const dataType = mapping?.dataType || (typeof fieldObj.value === 'number' ? 'INT' : 'TEXT');
                                            const options = mapping?.options || fieldObj.options || null;
                                            const label = mapping?.labelName || key.replace(/_/g, ' ');

                                            //console.log('rendering field', label, key, dataType, fieldObj.value);

                                            const renderOptions = (opts) => {
                                                if (!opts || !opts.length) return null;
                                                return opts.map((opt, i) => {
                                                    if (opt && typeof opt === 'object') {
                                                        const value = opt.value ?? opt.id ?? JSON.stringify(opt);
                                                        const text = opt.label ?? opt.name ?? opt.nameEn ?? String(value);
                                                        return <Select.Option key={i} value={value} style={{ fontSize: '12px' }}>{text}</Select.Option>;
                                                    }
                                                    return <Select.Option className="textStyles-small" key={i} value={opt} style={{ fontSize: '11px' }}>{String(opt)}</Select.Option>;
                                                });
                                            };
                                            return (
                                                <Col span={8} key={`col-${key}-${index}`}>
                                                    <Form.Item
                                                        label={<span className="textStyles-small">{label}</span>}
                                                        name={key}
                                                        key={`${key}-${index}`}
                                                        rules={[
                                                            {
                                                                required: mapping?.isRequired || false,
                                                                message: <span className="textStyles-small">Please enter {label}</span>,
                                                            }
                                                        ]}
                                                        initialValue={
                                                            dataType === 'DROPDOWN' &&
                                                                ![
                                                                    'isStandbyGeneratorAvailable',
                                                                    'pgPossibility',
                                                                    'isAccessPermissionRequired',
                                                                    'isSiteKeyRequired',
                                                                    'portablegenConnectingSetupAvailability',
                                                                    'isIdleGeneratorHutAvaialable',
                                                                    'isSpaceAvailableNewGen',
                                                                    'freeLandAvailable',
                                                                    'nonShadingSpaceAvailabilityOnshelter',
                                                                    'nonShadingSpaceAvailabilityGround',
                                                                    'manualTransport',
                                                                    'acCoolingMethod',
                                                                    'spaceForNewGen',
                                                                    'indoorCabinType'
                                                                ].includes(key)
                                                                ? fieldObj?.value?.id ?? null
                                                                : dataType === 'INT'
                                                                    ? Number(fieldObj?.value ?? 0)
                                                                    : dataType === 'TEXT'
                                                                        ? fieldObj?.value ?? null
                                                                        : dataType === 'DATE'
                                                                            ? fieldObj?.value
                                                                                ? moment(fieldObj?.value)
                                                                                : null
                                                                            : fieldObj?.value ?? null

                                                        }

                                                    >
                                                        {/* {dataType === 'DROPDOWN' ? (
                                                            <Select
                                                                bordered={false}
                                                                className='borderedSelect'
                                                                style={{ height: 38, width: '98%' }}
                                                            >
                                                                {options && options.length ? renderOptions(options) :
                                                                    <Select.Option value={fieldObj.value}>{fieldObj.value ?? null}</Select.Option>}
                                                            </Select>
                                                        ) : (
                                                            <Input
                                                                type={dataType === 'INT' ? 'number' : 'text'}
                                                                className='borderedSelect'
                                                                style={{ height: 38, width: '98%' }}
                                                            />
                                                        )} */}
                                                        {dataType === 'DROPDOWN' ? (
                                                            <Select
                                                                bordered={false}
                                                                className='borderedSelect'
                                                                style={{ height: 38, width: '98%' }}
                                                                placeholder={`Select ${label}`}
                                                                allowClear
                                                            >
                                                                {options && options.length ? renderOptions(options) :
                                                                    <Select.Option value={fieldObj.value}>{fieldObj.value ?? null}</Select.Option>}
                                                            </Select>
                                                        ) : dataType === 'DATE' ? (
                                                            <DatePicker
                                                                className='borderedSelect'
                                                                style={{ height: 38, width: '98%' }}
                                                                format="YYYY-MM-DD"
                                                                placeholder={`Select ${label}`}
                                                            />
                                                            // <></>
                                                        ) : (
                                                            <Input
                                                                type={dataType === 'INT' ? 'number' : 'text'}
                                                                className='borderedSelect'
                                                                style={{ height: 38, width: '98%' }}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            );
                                        })
                                }
                            </Row>
                            <Form.Item>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={loading}
                                        className="textStyles-small"
                                        style={{
                                            borderColor: '#BA183A',
                                            backgroundColor: '#BA183A',
                                            borderRadius: '10px',
                                            width: '100px',
                                            height: '34px'
                                        }}
                                    >
                                        Save Draft
                                    </Button>
                                    {
                                        draft?.missingFields === "" && (
                                            <Button
                                                type="primary"
                                                htmlType="button"
                                                onClick={moveDraft}
                                                loading={loading}
                                                className="textStyles-small"
                                                style={{
                                                    borderColor: '#28A745',
                                                    backgroundColor: '#28A745',
                                                    borderRadius: '10px',
                                                    width: '100px',
                                                    height: '34px'
                                                }}
                                            >
                                                Move Draft
                                            </Button>
                                        )
                                    }
                                </div>
                            </Form.Item>
                        </Form>
                    )}
                </div>
                {/* <pre>
                    {JSON.stringify(allPowerDetails, null, 2)}
                </pre> */}
            </div>
        </div>
    );
}

export default DraftEditor;